import { render, staticRenderFns } from "./InsurancesPlanDetails.vue?vue&type=template&id=336842b3&"
import script from "./InsurancesPlanDetails.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports